<div class="d-flex listing-icons align-items-center">
  <div class="tile-list-view cursor" *ngIf="toggle"><img src="../../../assets/images/list-view.svg" title="list view"
      (click)="onClick()" class="h-30" alt="list view"></div>
  <div class="tile-list-view cursor" *ngIf="!toggle"><img src="../../../assets/images/tile-view.svg" title="tile view"
      (click)="onClick()" class="h-30" alt="tile view"></div>
</div>